import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const getAxiosInstance = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    withCredentials: true,
  });
};

export function getInfluencerSubscriptionFromResponse(response) {
  return response?.data?.subscription ?? response?.data?.data?.subscription ?? null;
}

export const influencerSubscriptionService = {
  async getSubscription(options = {}) {
    const params = options.cacheBust ? { _: Date.now() } : undefined;
    const response = await getAxiosInstance().get('/payments/influencer-subscription', { params });
    return response.data;
  },

  async createSubscription(planType, billingCycle, billing = {}) {
    const response = await getAxiosInstance().post('/payments/influencer-subscription/create', {
      planType,
      billingCycle,
      name: billing?.name?.trim?.(),
      email: billing?.email?.trim?.(),
      mobile: billing?.mobile?.trim?.(),
    });
    return response.data;
  },

  async cancelSubscription() {
    const response = await getAxiosInstance().post('/payments/influencer-subscription/cancel');
    return response.data;
  },
};
